module.exports = __webpack_public_path__ + "static/media/datatrack.e7286849.svg";